<div class="right-panel__grid">
  <p-menu #gridMenu [model]="menuItems" [popup]="true" appendTo="body" styleClass="file-grid-popup-menu"></p-menu>

  <!-- Folders Row -->
  <div class="right-panel__grid-folders">
    @for (folder of folders; track folder.name) {
      <div
        class="right-panel__folder-card"
        [draggable]="folder.name !== '..'"
        (dragstart)="folder.name !== '..' && fileDragStart.emit({ event: $event, file: folder })"
        (click)="navigateToFolder.emit(folder)"
        style="cursor: pointer"
      >
        <div class="right-panel__folder-card-content">
          <app-svg-icon
            name="folder"
            [size]="28"
            color="var(--fm-primary)"
            class="right-panel__folder-card-icon"
          />
          <div class="right-panel__folder-card-info">
            <div class="right-panel__folder-card-name">{{ folder.name }}</div>
            @if (folder.name !== '..') {
              <div class="right-panel__folder-card-count">
                {{ folder.fileCount ?? 0 }} fájl · {{ folder.directoriesCount ?? 0 }} mappa
              </div>
            }
          </div>
        </div>
        @if (folder.name !== '..') {
          <button class="right-panel__grid-action-btn" (click)="openMenu($event, folder)">
            <app-svg-icon name="more-dots" [size]="20" />
          </button>
        }
        @if ((folder.links ?? 0) > 0) {
          <span class="right-panel__grid-link-badge">
            {{ folder.links }}<app-svg-icon name="link" [size]="12" color="#fff" />
          </span>
        }
      </div>
    }
  </div>

  <!-- Grid Toolbar -->
  <div class="right-panel__grid-toolbar">
    <button
      class="right-panel__grid-delete-btn"
      title="Kijelöltek törlése"
      (click)="deleteSelected.emit()"
    >
      <app-svg-icon name="trash" [size]="16" />
      <span>KIJELÖLTEK TÖRLÉSE</span>
    </button>
  </div>

  <!-- Files Grid -->
  <div class="right-panel__grid-files">
    @for (file of filesList; track file.name) {
      <div
        class="right-panel__file-card"
        [attr.data-filename]="file.name"
        [class.right-panel__file-card--scanning]="file.isScanning"
        [class.right-panel__file-card--highlighted]="file.name === highlightedFileName()"
        [draggable]="!file.isScanning"
        [pTooltip]="file.isScanning ? 'Vírusellenőrzés alatt' : ''"
        tooltipPosition="top"
        [appendTo]="'body'"
        (dragstart)="!file.isScanning && fileDragStart.emit({ event: $event, file })"
      >
        <div class="right-panel__file-card-header">
          <div class="right-panel__file-card-left">
            <p-checkbox
              name="selectedFiles"
              [value]="file"
              [ngModel]="selectedFiles"
              (ngModelChange)="onSelectedFilesChange($event)"
              [binary]="false"
              [disabled]="file.isScanning"
            />
            <app-svg-icon [name]="getFileIcon(file.extension)" [size]="20" />
            <span class="right-panel__file-card-name">{{ file.name }}</span>
          </div>
          <button class="right-panel__grid-action-btn" (click)="openMenu($event, file)">
            <app-svg-icon name="more-dots" [size]="20" />
          </button>
        </div>
        @if ((file.links ?? 0) > 0) {
          <span
            class="right-panel__grid-link-badge right-panel__grid-link-badge--clickable"
            (click)="$event.stopPropagation(); showLinks.emit(file)"
          >
            {{ file.links }}<app-svg-icon name="link" [size]="12" color="#fff" />
          </span>
        }
        <div class="right-panel__file-card-preview">
          @if (file.thumbnailUrl) {
            <img
              [src]="file.thumbnailUrl"
              [alt]="file.name"
              class="right-panel__file-card-thumbnail"
            />
          } @else {
            <!-- Picture frame placeholder image -->
            <svg
              class="right-panel__placeholder-img right-panel__svg-fluid"
              viewBox="0 0 240 160"
            >
              <rect x="0" y="0" width="240" height="160" rx="8" fill="#c4c9cc" />
              <rect x="16" y="16" width="208" height="128" fill="#f4f5f7" />
              <circle cx="76" cy="64" r="20" fill="#c4c9cc" />
              <path d="M16,144 Q56,100 96,128 T186,80 L224,144 Z" fill="#c4c9cc" />
            </svg>
          }
        </div>
      </div>
    }
  </div>
</div>
